const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  addToCart: 'add-to-cart',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  swatchChange: 'swatch-change',
  facetsUpdate: 'facets-update',
  ffProgresBarUpdate: 'frame-finder-progressbar-update',
  searchSubmit: 'search-submit',
  accountCreated: 'account-created',
  wishlistAdded: 'wishlist-added',
  newsletterSubscribed: 'newsletter-subscribed'
};

const FRAME_FINDER_ANSWER_KEYS = {
  coordinates: 'currentQuestionCoordinates',
  filterName: 'filterNames',
  filterValue: 'filterValues',
  nextCoordinates: 'nextQuestionCoordinates'
}

const FRAME_FINDER_KEYS = {
  localStorageKey: 'ff_answers',
  resultPageKey: 'results',
  filteredUrlKey: 'frame_finder_filter_url',
  firstQuestionKey: 'ff_first_question'
}
